import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BiDataHook, BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import GiveBadgeIcon from '@wix/da-ds/pkg/Icons/24x24/GiveBadge';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import ActionBarButtonRestricted from '../../_partials/ActionBarButtonRestricted';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
const AwardBadgeButton = ({ deviation, limitedBadgesPromo, onAwardClick })=>{
    var _limitedBadgesPromo;
    const { t } = useTranslation();
    const { restrictToLoggedIn } = useRestrictToLoggedIn();
    const typeId = getDeviationResourceType(deviation);
    const clickHandler = useCallback(()=>{
        onAwardClick(deviation);
    }, [
        onAwardClick,
        deviation
    ]);
    const tooltip = t('actionbar.awardBadge');
    return /*#__PURE__*/ React.createElement(ActionBarButtonRestricted, {
        subscribersOnly: true,
        deviation: deviation,
        tooltip: tooltip,
        button: /*#__PURE__*/ React.createElement(ActionBarButton, {
            onClick: restrictToLoggedIn(ReferralType.AWARD_BADGE, clickHandler),
            "data-hook": BiDataHook.DEVIATION_AWARD_BADGE_BUTTON,
            "aria-label": tooltip,
            biData: {
                evid: BiEventType.GIVE_BADGE_AWARD,
                sectionname: 'deviation',
                typeid: typeId,
                itemid: deviation.deviationId
            }
        }, ((_limitedBadgesPromo = limitedBadgesPromo) === null || _limitedBadgesPromo === void 0 ? void 0 : _limitedBadgesPromo.campaignIconOverride) ? /*#__PURE__*/ React.createElement("img", {
            src: limitedBadgesPromo.campaignIconOverride,
            width: "24",
            height: "24",
            alt: ""
        }) : /*#__PURE__*/ React.createElement(ActionBarIcon, {
            icon: GiveBadgeIcon
        }))
    });
};
AwardBadgeButton.displayName = 'AwardBadgeButton';
export default AwardBadgeButton;
